{
  "name": "@homer.core/session",
  "version": "1.15.0",
  "type": "module",
  "private": false,
  "config": {},
  "main": "./dist/index.js",
  "module": "./src/index.js",
  "exports": {
    ".": "./src/index.js",
    "./package.json": "./package.json"
  },
  "scripts": {},
  "dependencies": {
    "@homer.core/client.state": "*",
    "@homer.core/emitter": "*",
    "@homer.core/storage.cookie": "*",
    "@homer.core/storage.local": "*",
    "@homer.utility/uuid": "*"
  },
  "devDependencies": {},
  "requires": [],
  "loads": []
}
